export default [
  {
    path: '/business-information',
    name: 'business-information',
    component: () => import('@/views/businessInformation/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.updateBusinessInformation',
      navActiveLink: 'business-information',
      resource: 'modify-business-info',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.updateBusinessInformation',
          active: true,
        },
      ],
    },
  },
]
